define('modules/templates/models/template',['require','exports','module','backbone'],function(require, exports, module){
  "use strict";
  var Backbone = require("backbone");
  module.exports = Backbone.Model.extend({

  });
});
